module.exports = __webpack_public_path__ + "20e2f593681887ec817dd46ac51dcb67.svg";